import React, { useEffect, useState } from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { useFeatureFlags } from 'hooks/index';
import LoadableState from 'components/shared/loadable';
import LessonEventCard from 'components/LessonEvent/LessonEventCard';
import EventNotFoundGraphic from 'components/shared/EventNotFoundGraphic';
import Skeleton from 'ui/Skeleton';

const LessonEvent = ({ lessonEventId, previewing }) => {
  const [event, setEventData] = useState(null);
  const [sessions, setSessionsData] = useState(null);
  const [attendance, setAttendanceData] = useState(null);
  const [canChangeAttendance, setCanChangeAttendanceData] = useState(null);
  const [type, setTypeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newAttendance, setNewAttendance] = useState(false);
  const [eventNotFound, setEventNotFound] = useState(false);

  const hasEventsInLessonFeatureFlag = useFeatureFlags([
    'readiness-enable-events-in-lesson',
  ]);

  useEffect(() => {
    if (!loading) setLoading(true);
    request
      .get(
        `${window.location.pathname}${routes.LEARNING.LESSON_EVENT(
          lessonEventId,
        )}`,
      )
      .then(res => {
        if (res.register) {
          const content = res.register;
          setEventData(content.event);
          setSessionsData(content.sessions);
          setAttendanceData(content.attendance);
          setCanChangeAttendanceData(
            content.meta.policies.can_change_attendance,
          );
          setTypeData(content.type);
          setLoading(false);
          setNewAttendance(false);
        } else {
          setLoading(false);
        }
      })
      .fail(err => {
        if (err.status === 404) {
          setEventNotFound(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonEventId, newAttendance]);

  function previewNoEventSelected() {
    return previewing && !event && !eventNotFound;
  }

  return (
    <>
      {hasEventsInLessonFeatureFlag && !previewNoEventSelected() && (
        <>
          <div className="LessonEvent LessonEventCard d-f fd-c jc-c">
            {eventNotFound && <EventNotFoundGraphic isEditor={false} />}
            {loading && !eventNotFound && (
              <>
                <div className="loading" data-testid="lessonEventSkeleton">
                  <Skeleton height={28} className="mb-12 mt-8" width="25%" />
                  <Skeleton height={24} className="mb-8" />
                  <Skeleton height={20} className="mb-4" width="75%" />
                  <Skeleton height={20} className="mb-4" width="50%" />
                  <Skeleton height={20} className="mb-4" width="50%" />
                </div>
                <div className="LessonEventCard--controls d-f ai-c pl-24" />
              </>
            )}
            {!loading && (
              <LoadableState loading={loading} className="w-100p">
                <LessonEventCard
                  event={event}
                  previewing={previewing}
                  sessions={sessions}
                  attendance={attendance}
                  canChangeAttendance={canChangeAttendance}
                  type={type}
                  setNewAttendance={setNewAttendance}
                />
              </LoadableState>
            )}
          </div>
        </>
      )}
    </>
  );
};
export default LessonEvent;
